module.exports = __webpack_public_path__ + "img/i_quest_NORMAL_on.d3e53af.png";